import React, { PureComponent } from 'react';
import { bool, func, string, node, oneOfType } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { isNil } from '../../utils/utils';

class DialogModal extends PureComponent {
  static propTypes = {
    open: bool.isRequired,
    title: oneOfType([string, node]).isRequired,
    message: oneOfType([string, node]),
    onConfirm: func.isRequired,
    onCancel: func.isRequired,
    confirmText: oneOfType([string, node]),
    cancelText: oneOfType([string, node]),
    className: string,
  };

  static defaultProps = {
    title: <FormattedMessage id="modal.dialog.title" defaultMessage="Are you sure?" />,
  };

  constructor(props) {
    super(props);

    this.btnRef = null;
  }

  componentDidUpdate() {
    this.props.open && this.btnRef && this.btnRef.focus();
  }

  render() {
    const {
      open,
      title,
      message,
      onConfirm,
      onCancel,
      children,
      confirmText,
      cancelText,
      ...props
    } = this.props;

    return (
      <Modal backdrop="static" toggle={onCancel} isOpen={open} {...props} centered autoFocus>
        <ModalHeader toggle={onCancel}>{title}</ModalHeader>

        <ModalBody>{isNil(children) ? message : children}</ModalBody>

        <ModalFooter>
          <Button type="button" size="sm" color="light" onClick={onCancel}>
            {isNil(cancelText) ? <FormattedMessage id="main.no" defaultMessage="No" /> : cancelText}
          </Button>
          <Button
            innerRef={(btn) => (this.btnRef = btn)}
            type="button"
            size="sm"
            color="primary"
            onClick={onConfirm}
          >
            {isNil(confirmText) ? (
              <FormattedMessage id="main.yes" defaultMessage="Yes" />
            ) : (
              confirmText
            )}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default DialogModal;
